import { Select as AntdSelect, SelectProps } from "antd";
import { SelectValue } from "antd/lib/select";
import classes from "./styles.module.css";

export function Select<VT extends SelectValue = SelectValue>({ className = "", ...rest }: SelectProps<VT>) {
  return <AntdSelect {...rest} className={classes.input} />;
}
